{
  "ru": {
    "appSwitchButton": {
      "avia": "Авиа",
      "railways": "Ж/Д",
      "tours": "Туры",
      "hotels": "Отели"
    }
  },
  "kk": {
    "appSwitchButton": {
      "avia": "Әуе",
      "railways": "Т/Ж",
      "tours": "Турлар",
      "hotels": "Қонақ үйлер"
    }
  },
  "en": {
    "appSwitchButton": {
      "avia": "Avia",
      "railways": "Railways",
      "tours": "Tours",
      "hotels": "Hotels"
    }
  }
}
